import { faShieldHalved, faWallet, faClock } from '@fortawesome/free-solid-svg-icons';

import { FeatureCard } from '@/components/common';
import { TEXT } from '@/constants/static/registerLabels';

import skyline from '@/assets/images/skyline.svg';

import './HeroSection.css';

const featureIcons = [faShieldHalved, faWallet, faClock];

const HeroSection = () => {
  const { header, heroSection } = TEXT;

  return (
    <div className="nova-hero-section">
      <div className="nova-hero-content">
        <div className="nova-logo">
          <div className="nova-logo-mark">{header.logo}</div>
          <span className="nova-logo-text">{header.logoText}</span>
        </div>

        <h1 className="nova-hero-title">
          {heroSection.heroTitle}
          <br />
          {heroSection.heroSubTitle}
        </h1>

        <div className="nova-feature-cards">
          {heroSection.features.featureTitle.map((title, index) => (
            <FeatureCard
              key={title}
              icon={featureIcons[index]}
              title={title}
              description={heroSection.features.featureDescription[index]}
            />
          ))}
        </div>
      </div>

      <img src={skyline} alt="NovaBank Skyline" className="nova-skyline" />
    </div>
  );
};

export default HeroSection;
